var _rect, _rect2, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2285_2711)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2285_2711",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 28,
    width: 21,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 28,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2285_2711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5 32.5V31H49.5V32.5H37.5ZM42.75 45V36.875L40.5625 39.0625L39.5 38L43.5 34L47.5 38L46.4375 39.0625L44.25 36.875V45H42.75Z",
    fill: "#A557D5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4387 48.793V47.5156H39.2004V48.793H36.5871V56H35.0637V48.793H32.4387ZM47.291 51.7578C47.2969 54.5 45.6211 56.1172 43.4004 56.1172C41.168 56.1172 39.5039 54.4941 39.5098 51.7578C39.5039 49.0156 41.168 47.3984 43.4004 47.3984C45.6211 47.3984 47.2969 49.0156 47.291 51.7578ZM41.0449 51.7578C41.0391 53.6973 42.0176 54.7461 43.4004 54.7461C44.7891 54.7461 45.7617 53.6973 45.7559 51.7578C45.7617 49.8184 44.7891 48.7695 43.4004 48.7695C42.0176 48.7695 41.0391 49.8184 41.0449 51.7578ZM48.3504 56V47.5156H51.5379C53.4832 47.5156 54.5203 48.6992 54.5262 50.3281C54.5203 51.9512 53.4715 53.1289 51.5145 53.1289H49.8738V56H48.3504ZM49.8738 51.875H51.3035C52.452 51.8691 52.9676 51.2246 52.9676 50.3281C52.9676 49.4199 52.452 48.793 51.3035 48.793H49.8738V51.875Z",
    fill: "#A557D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2285_2711",
    x: 0,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2285_2711"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2285_2711",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTop);
export default __webpack_public_path__ + "static/media/Icon_Top.6fb46f7bad2b81f41775e6873183db52.svg";
export { ForwardRef as ReactComponent };